import { Component, Input } from '@angular/core'

import { TooltipModule } from 'primeng/tooltip'

@Component({
  selector: 'flx-confidence-indicator',
  standalone: true,
  templateUrl: './confidence.component.html',
  styleUrls: ['./confidence.component.scss'],
  imports: [TooltipModule],
})
export class FlxConfidenceIndicatorComponent {
  @Input() confidenceLevel = 0 // Float between 0 and 1

  levels = [0, 1, 2, 3, 4]

  getConfidenceLevel(): string {
    return (this.confidenceLevel * 100).toFixed(2)
  }

  getGradient(index: number): string {
    const colors = ['#8c660a', '#b4830d', '#e7a811', '#feb913', '#fec742']
    const level = this.confidenceLevel * 5 // Scale to 5 steps
    const fill = Math.min(1, Math.max(0, level - index)) // Determine how much to fill each box
    if (fill <= 0) {
      return '#475263'
    }
    if (fill >= 1) {
      return colors[index]
    }

    // Create a gradient for partial fill
    return `linear-gradient(to right, ${colors[index]} ${fill * 100}%, #475263 ${fill * 100}%)`
  }
}
